import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.object.assign";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import { apiRunner, apiRunnerAsync } from "./api-runner-browser";
import React from "react";
import ReactDOM from "react-dom";
import { Router, navigate, Location, BaseContext } from "@reach/router";
import { ScrollContext } from "gatsby-react-router-scroll";
import domReady from "@mikaelkristiansson/domready";
import { shouldUpdateScroll, init as navigationInit, RouteUpdates } from "./navigation";
import emitter from "./emitter";
import PageRenderer from "./page-renderer";
import asyncRequires from "./async-requires";
import { setLoader, ProdLoader, publicLoader, PageResourceStatus } from "./loader";
import EnsureResources from "./ensure-resources";
import stripPrefix from "./strip-prefix"; // Generated during bootstrap

import matchPaths from "./match-paths.json";
var loader = new ProdLoader(asyncRequires, matchPaths);
setLoader(loader);
loader.setApiRunner(apiRunner);
window.asyncRequires = asyncRequires;
window.___emitter = emitter;
window.___loader = publicLoader;
navigationInit();
apiRunnerAsync("onClientEntry").then(function () {
  // Let plugins register a service worker. The plugin just needs
  // to return true.
  if (apiRunner("registerServiceWorker").length > 0) {
    require("./register-service-worker");
  } // In gatsby v2 if Router is used in page using matchPaths
  // paths need to contain full path.
  // For example:
  //   - page have `/app/*` matchPath
  //   - inside template user needs to use `/app/xyz` as path
  // Resetting `basepath`/`baseuri` keeps current behaviour
  // to not introduce breaking change.
  // Remove this in v3


  var RouteHandler = function RouteHandler(props) {
    return /*#__PURE__*/React.createElement(BaseContext.Provider, {
      value: {
        baseuri: "/",
        basepath: "/"
      }
    }, /*#__PURE__*/React.createElement(PageRenderer, props));
  };

  var LocationHandler = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(LocationHandler, _React$Component);

    function LocationHandler() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = LocationHandler.prototype;

    _proto.render = function render() {
      var _this = this;

      var location = this.props.location;
      return /*#__PURE__*/React.createElement(EnsureResources, {
        location: location
      }, function (_ref) {
        var pageResources = _ref.pageResources,
            location = _ref.location;
        return /*#__PURE__*/React.createElement(RouteUpdates, {
          location: location
        }, /*#__PURE__*/React.createElement(ScrollContext, {
          location: location,
          shouldUpdateScroll: shouldUpdateScroll
        }, /*#__PURE__*/React.createElement(Router, {
          basepath: __BASE_PATH__,
          location: location,
          id: "gatsby-focus-wrapper"
        }, /*#__PURE__*/React.createElement(RouteHandler, Object.assign({
          path: pageResources.page.path === "/404.html" ? stripPrefix(location.pathname, __BASE_PATH__) : encodeURI(pageResources.page.matchPath || pageResources.page.path)
        }, _this.props, {
          location: location,
          pageResources: pageResources
        }, pageResources.json)))));
      });
    };

    return LocationHandler;
  }(React.Component);

  var _window = window,
      pagePath = _window.pagePath,
      browserLoc = _window.location; // Explicitly call navigate if the canonical path (window.pagePath)
  // is different to the browser path (window.location.pathname). But
  // only if NONE of the following conditions hold:
  //
  // - The url matches a client side route (page.matchPath)
  // - it's a 404 page
  // - it's the offline plugin shell (/offline-plugin-app-shell-fallback/)

  if (pagePath && __BASE_PATH__ + pagePath !== browserLoc.pathname && !(loader.findMatchPath(stripPrefix(browserLoc.pathname, __BASE_PATH__)) || pagePath === "/404.html" || pagePath.match(/^\/404\/?$/) || pagePath.match(/^\/offline-plugin-app-shell-fallback\/?$/))) {
    navigate(__BASE_PATH__ + pagePath + browserLoc.search + browserLoc.hash, {
      replace: true
    });
  }

  publicLoader.loadPage(browserLoc.pathname).then(function (page) {
    if (!page || page.status === PageResourceStatus.Error) {
      throw new Error("page resources for " + browserLoc.pathname + " not found. Not rendering React");
    }

    window.___webpackCompilationHash = page.page.webpackCompilationHash;

    var Root = function Root() {
      return /*#__PURE__*/React.createElement(Location, null, function (locationContext) {
        return /*#__PURE__*/React.createElement(LocationHandler, locationContext);
      });
    };

    var WrappedRoot = apiRunner("wrapRootElement", {
      element: /*#__PURE__*/React.createElement(Root, null)
    }, /*#__PURE__*/React.createElement(Root, null), function (_ref2) {
      var result = _ref2.result;
      return {
        element: result
      };
    }).pop();

    var NewRoot = function NewRoot() {
      return WrappedRoot;
    };

    var renderer = apiRunner("replaceHydrateFunction", undefined, ReactDOM.hydrate)[0];
    domReady(function () {
      renderer( /*#__PURE__*/React.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
        apiRunner("onInitialClientRender");
      });
    });
  });
});